import PaginatorDropdownSelector from './view/mobile';
export default PaginatorDropdownSelector;
